export enum USER_ROLES {
  ADMIN = 'ADMIN',
  USER = 'USER',
}
